import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import React from "react";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import SelectSearchUser from "@dropDesk/presentation/components/inputs/select_search_users";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";

const InputContactSearch = observer(
    ({
         setFilterUserClient,
         filterUserClient,
         filterClient,
         loading,
         hideLabel,
         size
     }: {
        setFilterUserClient: (filter: UserEntity | null, withList?: boolean) => void,
        filterUserClient: UserEntity | null
        filterClient: ClientEntity | null
        loading: boolean,
        hideLabel?: boolean,
        size?: number
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <>
                {!appController.isUserClient &&
                    <Tooltip title={hideLabel ? 'Filtrar por contato' : undefined}>
                        <div style={{display: "flex", flex: 1}}>
                            <SelectSearchUser
                                size={size ?? 40}
                                useRemoveFilter={!!filterUserClient}
                                label={hideLabel ? undefined : 'Filtrar por contato'}
                                placeHolder={"Pesquise por contato"}
                                handleSelectUser={(value, user) => {
                                    setFilterUserClient(user ?? null);
                                }}
                                idClient={filterClient?.id}
                                value={filterUserClient ? {
                                    value: filterUserClient.id,
                                    label: filterUserClient.name
                                } : undefined}

                                role={UserRole.userClient}
                                disabled={loading}
                                iconLeftName={ICONS_DROPDESK.account}
                                borderColor={filterUserClient ? colors.accent : colors.border}
                            />
                        </div>
                    </Tooltip>
                }
            </>
        )
    })
export default InputContactSearch;
